import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROGRESS_MEETING_FEATURE_KEY,
  ProgressMeetingState,
  ProgressMeetingPartialState,
  progressMeetingAdapter,
} from './progress-meeting.reducer';
import { ProgressMeetingReportDto } from '@cradua/data';

// Lookup the 'ProgressMeeting' feature state managed by NgRx
export const getProgressMeetingState = createFeatureSelector<
  ProgressMeetingPartialState,
  ProgressMeetingState
>(PROGRESS_MEETING_FEATURE_KEY);

const { selectAll, selectEntities } = progressMeetingAdapter.getSelectors();

export const getProgressMeetingLoaded = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => state.loaded
);

export const getProgressMeetingError = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => state.error
);

export const loadingProgressMeeting = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => state.loaded
);

export const getAllProgressMeeting = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => selectAll(state)
);

export const getProgressMeetingEntities = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProgressMeetingState,
  (state: ProgressMeetingState) => state.selectedProgressMeetingId
);

export const getSelected = createSelector(
  getProgressMeetingEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProgressMeeting,
  getSelectedId,
  (users: ProgressMeetingReportDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.MeetingReportDescription.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.MeetingReportTitle.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
